import { Col, Row } from "antd";
import styles from "./styles.module.scss";

interface KeyDatesProp {
  isOpen: boolean;
  title: string;
  closingDate: string;
  marginBtm: number;
}

const KeyDates = ({ isOpen, title, closingDate, marginBtm }: KeyDatesProp) => {
  return isOpen ? (
    <Row style={{ marginBottom: marginBtm }}>
      <Col span={18}>
        <div>
          <p className={styles["access-schemes-card_subtitle"]}>{title}</p>
          <span className={["show-desktop", styles["desktop-dates"]].join(" ")}>
            Closing: {closingDate}
          </span>
          <span className={["hide-desktop", styles.dates].join(" ")}>Closing: {closingDate}</span>
        </div>
      </Col>
      <Col span={6} style={{ textAlign: "right" }}>
        <span className={styles["open-tag"]}>Open</span>
      </Col>
    </Row>
  ) : (
    <Row style={{ marginBottom: marginBtm }}>
      <Col span={18}>
        <p className={styles["access-schemes-card_subtitle"]}>{title}</p>
      </Col>
      <Col span={6} style={{ textAlign: "right" }}>
        <span className={styles["close-tag"]}>Closed</span>
      </Col>
    </Row>
  );
};

export default KeyDates;
